import type { ProductReference, Variant } from '@storefront/lib-global/codegen/types';
import { StockStatus } from '@storefront/lib-global/codegen/types';

export const areSizeAndWidthDisplayed = (
  variants: Variant[],
  isSubdomainOutlet: boolean,
  largerSizeProduct: ProductReference | undefined,
  smallerSizeProduct: ProductReference | undefined,
): boolean => {
  const isAllOutOfStock = variants.every((variant) => variant.stock.status === StockStatus.OUTOFSTOCK);
  const hasLargerAndSmallerSizes = !!largerSizeProduct || !!smallerSizeProduct;
  return isAllOutOfStock ? !isSubdomainOutlet || hasLargerAndSmallerSizes : true;
};
